import formatCartState from '../utils/format-cart-state';

const ecommerceReducer = (state, action) => formatCartState({ ...state, ...action });

export default ecommerceReducer;
